import { useQuery } from '@tanstack/react-query';
import { fetchCurrentUserAccess } from './useCurrentUserRole';

/**
 * Fetches the organization ID for the currently authenticated user.
 */
export const fetchUserOrgId = async ({ client } = {}) => {
  const access = await fetchCurrentUserAccess({ client });
  if (!access?.organizationId) {
    throw new Error('User profile is not associated with an organization.');
  }
  return access.organizationId;
};

export const useUserOrgId = ({ enabled = true } = {}) =>
  useQuery({
    enabled,
    queryKey: ['userOrgId'],
    queryFn: fetchUserOrgId,
    staleTime: 15 * 60 * 1000,
    retry: false,
  });
